module.exports = __webpack_public_path__ + "img/08.aa7abe07.jpg";